import React, { useState } from "react";
import {
  getOtpReference,
  verifyMobileNumber,
  verifyMobileNumberForPWALogin,
} from "src/Commons/Auth/Service/Auth.service";

import {
  parseRealMobileVal,
  phoneFormat,
} from "src/Shared/Utils/MobileNumberUnits";
import { pathOr } from "ramda";
import { ToastSeverity } from "src/Shared/Components/Toast/Enum";
import { useHistory } from "react-router-dom";
import { LOGIN_OTP_ROUTE_PATH } from "src/Main/Nav/AppNavUrls.constant";
import { isMobileOnly } from "react-device-detect";
import { VerifyMobileNumberResult } from "src/Commons/Auth/Models";
import toastService from "src/Shared/Components/Toast/ToastService";

interface ComponentProps {
  mobileNumberRefId?: string;
  mobileNumber?: string;
  otpRefId?: string;
  onChangeMobileNumberRefId?: (value: string) => void;
  onChangeOtpRefId?: (value: string) => void;
  onChangeMobile?: (value: string) => void;
  onLoadingChange: (value: boolean) => void;
  loading: boolean;
  currentSlide?: number;
  isError?: boolean;
  onChangeError?: (error: boolean) => void;
  disableHocError?: boolean;
  isPWAError?: boolean;
  handlePWAError?: (value: boolean) => void;
  onOpenModal?: () => void;
}

const WithVerifyMobileNumber = () => (Component: React.ComponentType<any>) => {
  const WrappedComponent: React.FC<ComponentProps> = (props) => {
    const {
      mobileNumber,
      onChangeMobileNumberRefId,
      onChangeOtpRefId,
      onLoadingChange,
      currentSlide,
      handlePWAError,
      onOpenModal,
    } = props;
    const { replace } = useHistory();
    const [isError, setIsError] = useState(false);
    const [isPwaError, setIsPwaError] = useState(false);

    const verifyNumber = async (e?: any) => {
      localStorage.setItem("mobileNumber",parseRealMobileVal(mobileNumber))
      e?.preventDefault();
      if (
        mobileNumber?.length === 10
          ? false
          : mobileNumber?.length === 16
            ? false
            : true
      ) {
        setIsError(true);
        return;
      }
      onLoadingChange(true);
      let mobileNumberResponse: VerifyMobileNumberResult;
      if (isMobileOnly) {
        mobileNumberResponse = await verifyMobileNumberForPWALogin({
          CountryCode: "+1",
          Number: parseRealMobileVal(mobileNumber),
        });
      } else {
        mobileNumberResponse = await verifyMobileNumber({
          CountryCode: "+1",
          Number: parseRealMobileVal(mobileNumber),
        });
      }
      if (pathOr("", ["refId"], mobileNumberResponse)) {
        if (onChangeMobileNumberRefId) {
          onChangeMobileNumberRefId(
            pathOr("", ["refId"], mobileNumberResponse),
          );
        }
        getOTPRefId(pathOr("", ["refId"], mobileNumberResponse));
      } else {
        if (mobileNumberResponse?.errorMessage) {
          if (isMobileOnly) {
            if (handlePWAError) {
              handlePWAError(true);
            }
            onLoadingChange(false);
            return;
          } else {
            toastService.openToast(
              true,
              ToastSeverity.Error,
              mobileNumberResponse.errorMessage,
            );
          }
        }
        onLoadingChange(false);
      }
    };

    const getOTPRefId = async (mobileNumberRefId: any) => {
      onLoadingChange(true);
      const otpResponse = await getOtpReference(mobileNumberRefId);
      if (pathOr("", ["refId"], otpResponse)) {
        if (onChangeOtpRefId) {
          onChangeOtpRefId(pathOr("", ["refId"], otpResponse));
        }

        replace(
          `${LOGIN_OTP_ROUTE_PATH}?mobileRefId=${mobileNumberRefId}&mobileNumber=${parseRealMobileVal(
            mobileNumber,
          )}&currentSlide=${currentSlide}`,
          {
            mobileNumber: parseRealMobileVal(mobileNumber),
            mobileRefId: mobileNumberRefId,
            otpRefId: otpResponse.refId,
            currentSlide: currentSlide,
          },
        );
        onLoadingChange(false);
      } else {
        if (otpResponse?.errorMessage) {
          toastService.openToast(
            true,
            ToastSeverity.Error,
            otpResponse.errorMessage,
          );
        }
        onLoadingChange(false);
      }
    };

    return React.createElement(Component, {
      ...props,
      verifyNumber,
      isError: props?.disableHocError ? props.isError : isError,
      isPWAError: props.isPWAError,
    });
  };
  return WrappedComponent;
};

export default WithVerifyMobileNumber;
